type TFunction = (key: string, defaultValue?: any) => string

/**
 * 操作类型枚举（数字，与后端保持一致）
 * GENERATE=100, PAY=21, REFUND=23
 * ADJUST_INC=1201, ADJUST_DEC=2201
 * BATCH_ADJUST_INC=1202, BATCH_ADJUST_DEC=2202
 * EXPIRY=2402, SYS_CLEAR=2401
 */
export enum ActionType {
  ALL = 0,                    // 不限（前端虚拟值，不传给后端）
  DISBURSE = 100,             // 津贴下发
  PAYMENT = 21,               // 订单支付
  REFUND = 23,                // 订单退款
  ADJUST_INC = 1201,          // 手动调整（增加）
  ADJUST_DEC = 2201,          // 手动调整（扣减）
  BATCH_ADJUST_INC = 1202,    // 文件批量调整（增加）
  BATCH_ADJUST_DEC = 2202,    // 文件批量调整（扣减）
  EXPIRY = 2402,              // 津贴失效
  SYS_CLEAR = 2401,           // 系统清零
}

/** 员工状态枚举值 */
export enum StaffStatus {
  ACTIVE = 'active',
  RESIGNED = 'resigned',
}

/** 余额调整方式 */
export enum AdjustType {
  TARGET_AMOUNT = 1,   // 设置绝对值（调整后金额）
  DELTA_AMOUNT = 2,    // 增量调整（增减金额）
}

/** 获取操作类型展示文案（actionTypeDesc 由后端返回，此处作为兜底） */
export const getActionTypeText = (actionType: number, t: TFunction): string => {
  const map: Record<number, string> = {
    [ActionType.DISBURSE]: t('e_pc_type_disburse', '津贴下发'),
    [ActionType.PAYMENT]: t('e_pc_type_payment', '订单支付'),
    [ActionType.REFUND]: t('e_pc_type_refund', '订单退款'),
    [ActionType.ADJUST_INC]: t('e_pc_type_manual_adjust', '手动调整'),
    [ActionType.ADJUST_DEC]: t('e_pc_type_manual_adjust', '手动调整'),
    [ActionType.BATCH_ADJUST_INC]: t('e_pc_type_batch_adjust', '文件批量调整'),
    [ActionType.BATCH_ADJUST_DEC]: t('e_pc_type_batch_adjust', '文件批量调整'),
    [ActionType.EXPIRY]: t('e_pc_type_expired', '津贴失效'),
    [ActionType.SYS_CLEAR]: t('e_pc_type_sys_clear', '系统清零'),
  }
  return map[actionType] || String(actionType)
}

/** 获取员工状态展示文案 */
export const getStaffStatusText = (status: string, t: TFunction) => {
  const map: Record<string, string> = {
    [StaffStatus.ACTIVE]: t('e_pc_active', '在职'),
    [StaffStatus.RESIGNED]: t('e_pc_resigned', '离职'),
  }
  return map[status] || status
}

/**
 * 操作类型下拉选项
 * 手动调整 / 文件批量调整各有增减两个 code，筛选时合并传给后端
 */
export const ACTION_TYPE_MULTI_MAP: Record<number, number[]> = {
  [ActionType.ADJUST_INC]: [ActionType.ADJUST_INC, ActionType.ADJUST_DEC],
  [ActionType.BATCH_ADJUST_INC]: [ActionType.BATCH_ADJUST_INC, ActionType.BATCH_ADJUST_DEC],
}

export const getActionTypeOptions = (t: TFunction) => [
  { label: t('e_pc_opt_unlimited', '不限'), value: ActionType.ALL },
  { label: t('e_pc_type_disburse', '津贴下发'), value: ActionType.DISBURSE },
  { label: t('e_pc_type_payment', '订单支付'), value: ActionType.PAYMENT },
  { label: t('e_pc_type_refund', '订单退款'), value: ActionType.REFUND },
  { label: t('e_pc_type_manual', '单笔手动调整'), value: ActionType.ADJUST_INC },
  { label: t('e_pc_type_bulk', '文件批量调整'), value: ActionType.BATCH_ADJUST_INC },
  { label: t('e_pc_type_expired', '津贴失效'), value: ActionType.EXPIRY },
  // { label: t('e_pc_type_sys_clear', '系统清零'), value: ActionType.SYS_CLEAR },
]

/** 可点击跳转订单详情的操作类型 */
export const ORDER_LINK_ACTION_TYPES = [ActionType.PAYMENT, ActionType.REFUND]

/** 展示调整原因备注的操作类型（手动调整 + 文件批量调整，增减均算） */
export const REMARK_ACTION_TYPES = [
  ActionType.ADJUST_INC,
  ActionType.ADJUST_DEC,
  ActionType.BATCH_ADJUST_INC,
  ActionType.BATCH_ADJUST_DEC,
]
